import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GameCard.css';

function GameCard({ title, image, link }) {
  const [isFlipped, setIsFlipped] = useState(false);

  // Telegram Bot URL
  const telegramBotUrl = 'https://t.me/Versusarenaentry_bot';

  return (
    <div
      className={`game-card-container ${isFlipped ? 'is-flipped' : ''}`}
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      onClick={() => setIsFlipped(!isFlipped)} // Mobile tap support
    >
      <div className="game-card-flipper">
        {/* Vorderseite der Karte */}
        <div className="game-card-front">
          {image ? (
            <img 
              src={image} 
              alt={title} 
              className="game-image"
              onError={(e) => {
                console.warn(`Image failed to load for ${title}:`, image);
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div 
            className="game-image-fallback" 
            style={{
              display: image ? 'none' : 'flex',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, #6c5ce7, #74b9ff)',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '4rem'
            }}
          >
            🎮
          </div>
          <div className="game-info">
            <h3 className="game-title-moved">{title}</h3>
          </div>
        </div>

        {/* Rückseite der Karte - erweitert mit 3 Buttons */}
        <div className="game-card-back">
          <div className="card-back-content">
            <h4 className="card-back-title">{title}</h4>
            
            <div className="card-back-buttons">
              <a 
                href={telegramBotUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="card-action-button play-now-btn"
                onClick={(e) => e.stopPropagation()}
              >
                🎮 PLAY NOW
              </a>
              
              <Link 
                to="/tournaments" 
                className="card-action-button tournaments-btn"
                onClick={(e) => e.stopPropagation()}
              >
                🏆 TOURNAMENTS
              </Link>
              
              <Link 
                to={link} 
                className="card-action-button games-btn"
                onClick={(e) => e.stopPropagation()}
              >
                🎯 GAME DETAILS
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameCard;